import { useEffect, useState } from 'react';

const useFetchResource = ({ resourceCallback, isReady = false }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState();
  const [errors, setErrors] = useState();

  const fetchResource = async () => {
    setIsLoading(true);
    const { data: fetchData } = await resourceCallback();

    if (!fetchData) return setErrors('Fetch Failed');

    setIsLoading(false);
    setIsLoaded(true);
    return setData(fetchData);
  };

  useEffect(() => {
    if (resourceCallback && !errors && !isLoading && !isLoaded && isReady) {
      fetchResource();
    }
  }, [isReady]);

  return {
    isLoaded,
    data,
    errors
  };
};

export default useFetchResource;



// WEBPACK FOOTER //
// ./helpers/hooks/use-fetch-resource.js